module.exports = __webpack_public_path__ + "img/ico-mail.3bcc2e79.svg";